import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";

// import i18n (needs to be bundled ;)) 
import './i18n/config';

ReactDOM.render(<App />, document.getElementById("root"));
